/**
 * Shared utility functions for building Shared Insights messages.
 * Used across EditExceptionFlyout, ExceptionsOverview, and AdequacyDetails.
 */

export const getGapSharedInsightsMessage = (
  gapSharedInsightsCount: number,
  gapSharedInsightsPayerCount: number
): string | null => {
  if (gapSharedInsightsCount === 0) {
    return null;
  }

  return `${gapSharedInsightsCount} network gap${gapSharedInsightsCount === 1 ? " is" : "s are"} present in ${gapSharedInsightsPayerCount} payer${gapSharedInsightsPayerCount === 1 ? "" : "s"}`;
};

export const getExceptionSharedInsightsPreviousYearApprovalsMessage = (count: number): string | null => {
  if (count === 0) {
    return null;
  }

  return `${count} exception${count > 1 ? "s" : ""} approved last year.`;
};

export const getExceptionSharedInsightsInProgressMessage = (count: number): string | null => {
  if (count === 0) {
    return null;
  }

  return `${count} exception${count > 1 ? "s" : ""} in progress for the upcoming plan year.`;
};

export const getExceptionSharedInsightsMessage = (
  previousYearApprovalsCount: number,
  inProgressCount: number
): string | null => {
  const approvedMessage = getExceptionSharedInsightsPreviousYearApprovalsMessage(previousYearApprovalsCount);
  const inProgressMessage = getExceptionSharedInsightsInProgressMessage(inProgressCount);

  if (!approvedMessage && !inProgressMessage) {
    return null;
  }

  return [approvedMessage, inProgressMessage].filter(Boolean).join(" ");
};

export const validateSharedInsights = (hasProjectExceptionPackage: boolean, count: number): string | null =>
  !hasProjectExceptionPackage
    ? "These insights are not available within your current license configuration."
    : count === 0
      ? "There are no available insights."
      : null;
